import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import HomeService from "../../../Services/HomeService";
import toast from "react-hot-toast";

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "15px",
    fontWeight: "bold",
};

function ManageBlogCategory() {
    const [blogCategories, setBlogCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [propertyTypeID, setPropertyTypeID] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [editData, setEditData] = useState({ catName: "" });

    const columns = [
        { name: "S.No.", selector: (row) => row.sln, sortable: true },
        { name: "Property Type", selector: (row) => row.catName, sortable: true },
        {
            name: "Action",
            cell: (row) => (
                <>
                    <span title="Edit" onClick={() => handleEdit(row)}>
                        <i
                            className="fa-solid fa-pen-to-square"
                            style={{
                                cursor: "pointer",
                                padding: "5px",
                                marginRight: "5px",
                                fontSize: "1.5em",
                                color: "rgb(133, 218, 79)",
                                backgroundColor: "#E9F3F7",
                            }}
                        ></i>
                    </span>
                    <span title="Delete" onClick={() => handleDelete(row.id)}>
                        <i
                            className="fa-solid fa-trash-can text-danger"
                            style={{
                                cursor: "pointer",
                                padding: "5px",
                                marginRight: "5px",
                                fontSize: "1.5em",
                                color: "#477DA5",
                                backgroundColor: "#E9F3F7",
                            }}
                        ></i>
                    </span>
                </>
            ),
        },
    ];

    const fetchAllDAta = async () => {
        setLoading(true);
        try {
            const res = await HomeService.getBlogCategory();
            const arr = res?.data?.map((ele, ind) => ({
                sln: ind + 1,
                catName: ele.catName,
                id: ele._id,
            }));
            setBlogCategories(arr);
        } catch (error) {
            console.error("Error fetching property types:", error);
            toast.error("Failed to load property types!");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllDAta();
    }, []);

    const handleEdit = (row) => {
        setIsEdit(true);
        setEditData({ catName: row.catName });
        setPropertyTypeID(row.id);
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Delete Blog Category?",
            text: "Are you sure you want to delete this Blog Category?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            confirmButtonColor: "#d33",
            cancelButtonText: "Cancel",
            reverseButtons: true,
        });
        if (result.isConfirmed) {
            try {
                await HomeService.deleteBlogCategory(id);
                Swal.fire("Deleted!", "Blog Category has been deleted.", "success");
                fetchAllDAta();
            } catch (error) {
                Swal.fire("Error!", "Failed to delete Blog Category.", "error");
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const data = { catName: editData.catName };
            if (isEdit) {
                await HomeService.updateBlogCategory(propertyTypeID, data);
                toast.success("BlogCategory updated successfully!");
            } else {
                await HomeService.addBlogCategory(data);
                toast.success("BlogCategory added successfully!");
            }
            setIsEdit(false);
            setEditData({ catName: "" });
            fetchAllDAta();
        } catch (error) {
            toast.error("Failed to save property type.");
            console.error("Error saving property type:", error);
        }
    };

    return (
        <>
            <div className="main_wrap" style={{ marginTop: "6rem" }}>
                <div className="container-fluid">
                    {isEdit && (
                        <section className="chartBox_area">
                            <h2>Edit Blog Category</h2>
                            <hr />
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="propertyTypeName">
                                            Category Name<span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="propertyTypeName"
                                            className="form-control"
                                            value={editData.catName}
                                            onChange={(e) =>
                                                setEditData({ ...editData, catName: e.target.value })
                                            }
                                            placeholder="Enter Property Type Name"
                                        />
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-primary mt-3">
                                    Save Changes
                                </button>
                            </form>
                        </section>
                    )}

                    <div className="mt-5">
                        <div style={headLineStyle} className="page-headline">
                            Manage Blog Categories
                        </div>
                        {loading ? (
                            <p>Loading...</p>
                        ) : (
                            <DataTable
                                columns={columns}
                                data={blogCategories}
                                pagination
                                responsive
                                highlightOnHover
                            />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default ManageBlogCategory;
